import { useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import s from './ContractorAwardedModal.scss'
import { fromAwardedCompanies } from 'utils/serializers'
import { DatePicker, KeyValuePairs } from 'components/ideal-core-ui'
import { PaginatedSelect } from 'components/common/PaginatedSelect'
import { toCompaniesSelect } from 'components/Companies/serializers'
import { timezoneDate, utcDate } from 'utils/helpers'
import { GiPartyPopper } from 'react-icons/gi'

const ContractorAwardedModal = ({
  showContractorAwardedModal,
  toggleContractorAwardedModal,
  entity,
  onSave,
  cancelCb,
  isWonByUs,
  status
}) => {
  const [dealAwarded, setDealAwarded] = useState(entity.awardedCompany || true)
  const [followUpDate, setFollowUpDate] = useState(entity.followUpDate || null)
  const [awardedCompany, setAwardedCompany] = useState(
    entity.awardedCompany
      ? entity.awardedCompany?.value
        ? entity.awardedCompany
        : fromAwardedCompanies(entity.awardedCompany)
      : entity.dealCompanies?.length === 1
        ? entity.dealCompanies[0].company
          ? fromAwardedCompanies(entity.dealCompanies[0].company)
          : entity.dealCompanies[0]
        : null
  )
  const [bidStatus, setBidStatus] = useState({ value: 3, label: 'Bidding Awarded' })

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showContractorAwardedModal}
        toggle={toggleContractorAwardedModal}
      >
        {!isWonByUs && (
          <ModalHeader toggle={cancelCb} className={s.modalHeader}>
            {!entity.awardedCompany ? 'Set Contractor Awarded' : 'Set Follow Up Date'}
          </ModalHeader>
        )}
        <ModalBody>
          {isWonByUs && (
            <div style={{ textAlign: 'center' }}>
              <GiPartyPopper className={s.partyIcon} />
              <h4 style={{ padding: '20px 0' }}>Congrats on winning the opportunity!</h4>
              {!entity.awardedCompany && <p>Please set the awarded client.</p>}
            </div>
          )}
          <div className={s.dealAwarded}>
            {!entity.awardedCompany && (
              <>
                {!isWonByUs && (
                  <>
                    Opportunity Awarded:
                    <input
                      type="radio"
                      checked={dealAwarded}
                      onChange={() => {
                        setDealAwarded(true)
                      }}
                    />{' '}
                    Yes
                    <input
                      type="radio"
                      checked={!dealAwarded}
                      onChange={() => {
                        setDealAwarded(false)
                        setAwardedCompany(null)
                        setBidStatus({ value: 2, label: 'Bidding' })
                      }}
                    />{' '}
                    No
                  </>
                )}
                {((isWonByUs && !entity.awardedCompany) || (!isWonByUs && dealAwarded)) && (
                  <PaginatedSelect
                    url="/v1/companies"
                    className={s.clients}
                    value={awardedCompany}
                    onChange={value => {
                      setAwardedCompany(value)
                      setBidStatus({ value: 3, label: 'Bidding Awarded' })
                    }}
                    serializer={toCompaniesSelect}
                  />
                )}
              </>
            )}
          </div>
          {!isWonByUs && (
            <KeyValuePairs
              pairs={[
                {
                  key: 'Select follow-up date:',
                  value: (
                    <DatePicker
                      value={followUpDate ? timezoneDate(followUpDate) : ''}
                      onChange={value => {
                        const date = value ? utcDate(value) : ''
                        setFollowUpDate(date)
                      }}
                    />
                  )
                }
              ]}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className={s.saveBtn}
            disabled={!awardedCompany}
            onClick={() => onSave({ awardedCompany, bidStatus, followUpDate, status })}
          >
            {(isWonByUs && !entity.awardedCompany) || !isWonByUs ? 'Save' : 'Close'}
          </Button>
          {((isWonByUs && !entity.awardedCompany) || !isWonByUs) && (
            <Button color="secondary" onClick={cancelCb}>
              Cancel
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ContractorAwardedModal
